"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DayCell = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styled = _interopRequireDefault(require("../../../../styled"));

var _CalendarGrid = require("./CalendarGrid");

var _dateParts = require("../../date-parts");

var _types = require("../../date-parts/types");

var _polished = require("polished");

var _templateObject, _templateObject2;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var DayElement = _styled["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 2rem;\n  width: 2rem;\n  border-radius: 50%;\n  font-size: 0.75rem;\n  font-weight: ", ";\n  border: 2px solid transparent;\n  transition: border-color 300ms, background-color 300ms, color 300ms;\n  background-color: ", ";\n  color: ", ";\n"])), function (_ref) {
  var isToday = _ref.isToday;
  return isToday ? 'bold' : undefined;
}, function (_ref2) {
  var theme = _ref2.theme,
      isSelected = _ref2.isSelected;
  return isSelected ? theme.primary : 'transparent';
}, function (_ref3) {
  var theme = _ref3.theme,
      isSelected = _ref3.isSelected;
  return isSelected ? theme.background : theme.foreground;
});

var DayContainerElement = (0, _styled["default"])(_CalendarGrid.CalendarGridCellElement)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  opacity: ", ";\n  transition: opacity 300ms;\n  pointer-events: ", ";\n\n  ", " {\n    z-index: 1;\n  }\n\n  &:hover ", " {\n    border-color: ", ";\n  }\n\n  &:before,\n  &:after {\n    content: '';\n    box-sizing: border-box;\n    position: absolute;\n    top: 0;\n    height: 100%;\n    width: 50%;\n    transition: background-color 300ms, border-color 300ms;\n    z-index: 0;\n    border-width: 2px 0;\n    border-style: dashed;\n    border-color: ", ";\n    background-color: ", ";\n  }\n\n  &:before {\n    background-color: ", ";\n    border-color: ", ";\n    left: 0;\n  }\n\n  &:after {\n    background-color: ", ";\n    border-color: ", ";\n    left: 50%;\n  }\n"])), function (_ref4) {
  var disabled = _ref4.disabled;
  return disabled ? 0.3 : 1;
}, function (_ref5) {
  var disabled = _ref5.disabled;
  return disabled ? 'none' : 'auto';
}, DayElement, DayElement, function (_ref6) {
  var theme = _ref6.theme;
  return (0, _polished.transparentize)(0.5, theme.foreground);
}, function (_ref7) {
  var theme = _ref7.theme;
  return (0, _polished.transparentize)(0.8, theme.foreground);
}, function (_ref8) {
  var theme = _ref8.theme;
  return (0, _polished.transparentize)(0.7, theme.primary);
}, function (_ref9) {
  var isSelectingRange = _ref9.isSelectingRange,
      isInSelectedRange = _ref9.isInSelectedRange,
      isMinSelected = _ref9.isMinSelected;
  return isSelectingRange && isInSelectedRange && !isMinSelected ? undefined : 'transparent';
}, function (_ref10) {
  var isSelectingRange = _ref10.isSelectingRange,
      isInSelectingRange = _ref10.isInSelectingRange,
      isMinSelecting = _ref10.isMinSelecting;
  return isSelectingRange && isInSelectingRange && !isMinSelecting ? undefined : 'transparent';
}, function (_ref11) {
  var isSelectingRange = _ref11.isSelectingRange,
      isInSelectedRange = _ref11.isInSelectedRange,
      isMaxSelected = _ref11.isMaxSelected;
  return isSelectingRange && isInSelectedRange && !isMaxSelected ? undefined : 'transparent';
}, function (_ref12) {
  var isSelectingRange = _ref12.isSelectingRange,
      isInSelectingRange = _ref12.isInSelectingRange,
      isMaxSelecting = _ref12.isMaxSelecting;
  return isSelectingRange && isInSelectingRange && !isMaxSelecting ? undefined : 'transparent';
});

var DayCell = function DayCell(_ref13) {
  var date = _ref13.date,
      min = _ref13.min,
      max = _ref13.max,
      display = _ref13.display,
      selected = _ref13.selected,
      onClick = _ref13.onClick,
      onMouseEnter = _ref13.onMouseEnter,
      onMouseLeave = _ref13.onMouseLeave,
      isSelectingRange = _ref13.isSelectingRange,
      maxSelectedDate = _ref13.maxSelectedDate,
      minSelectedDate = _ref13.minSelectedDate,
      maxSelectingDate = _ref13.maxSelectingDate,
      minSelectingDate = _ref13.minSelectingDate;

  var _useState = (0, _react.useState)(new _dateParts.DateParts(display[_types.DatePartEnum.YEAR], display[_types.DatePartEnum.MONTH], date)),
      _useState2 = _slicedToArray(_useState, 2),
      cellDate = _useState2[0],
      setCellDate = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isSelected = _useState4[0],
      setIsSelected = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isMaxSelected = _useState6[0],
      setIsMaxSelected = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = _slicedToArray(_useState7, 2),
      isMinSelected = _useState8[0],
      setIsMinSelected = _useState8[1];

  var _useState9 = (0, _react.useState)(false),
      _useState10 = _slicedToArray(_useState9, 2),
      isInSelectedRange = _useState10[0],
      setIsInSelectedRange = _useState10[1];

  var _useState11 = (0, _react.useState)(false),
      _useState12 = _slicedToArray(_useState11, 2),
      isMaxSelecting = _useState12[0],
      setIsMaxSelecting = _useState12[1];

  var _useState13 = (0, _react.useState)(false),
      _useState14 = _slicedToArray(_useState13, 2),
      isMinSelecting = _useState14[0],
      setIsMinSelecting = _useState14[1];

  var _useState15 = (0, _react.useState)(false),
      _useState16 = _slicedToArray(_useState15, 2),
      isInSelectingRange = _useState16[0],
      setIsInSelectingRange = _useState16[1];

  (0, _react.useEffect)(function () {
    var newDateParts = new _dateParts.DateParts(display[_types.DatePartEnum.YEAR], display[_types.DatePartEnum.MONTH], date);

    if (!cellDate.isEqualTo(newDateParts)) {
      setCellDate(newDateParts);
    }
  }, [date, display, cellDate]);
  (0, _react.useEffect)(function () {
    selected ? setIsSelected(!!selected.find(function (value) {
      return cellDate.isEqualTo(value);
    })) : setIsSelected(false);
  }, [cellDate, selected]);
  (0, _react.useEffect)(function () {
    setIsMinSelected(!!(minSelectedDate && cellDate.isEqualTo(minSelectedDate)));
    setIsMaxSelected(!!(maxSelectedDate && cellDate.isEqualTo(maxSelectedDate)));
    setIsInSelectedRange(!!(minSelectedDate && maxSelectedDate && cellDate.isGreaterThanOrEqualTo(minSelectedDate) && cellDate.isLessThanOrEqualTo(maxSelectedDate)));
  }, [cellDate, minSelectedDate, maxSelectedDate]);
  (0, _react.useEffect)(function () {
    setIsMinSelecting(!!(minSelectingDate && cellDate.isEqualTo(minSelectingDate)));
    setIsMaxSelecting(!!(maxSelectingDate && cellDate.isEqualTo(maxSelectingDate)));
    setIsInSelectingRange(!!(minSelectingDate && maxSelectingDate && cellDate.isGreaterThanOrEqualTo(minSelectingDate) && cellDate.isLessThanOrEqualTo(maxSelectingDate)));
  }, [cellDate, minSelectingDate, maxSelectingDate]);

  var mouseEventHandlerGenerator = function mouseEventHandlerGenerator(handler) {
    return function (event) {
      handler && handler(cellDate, event);
    };
  };

  return /*#__PURE__*/_react["default"].createElement(DayContainerElement, {
    onClick: mouseEventHandlerGenerator(onClick),
    onMouseEnter: mouseEventHandlerGenerator(onMouseEnter),
    onMouseLeave: mouseEventHandlerGenerator(onMouseLeave),
    isSelectingRange: isSelectingRange,
    isMaxSelected: isMaxSelected,
    isMinSelected: isMinSelected,
    isInSelectedRange: isInSelectedRange,
    isMaxSelecting: isMaxSelecting,
    isMinSelecting: isMinSelecting,
    isInSelectingRange: isInSelectingRange,
    disabled: cellDate.isLessThan(min) || cellDate.isGreaterThan(max)
  }, /*#__PURE__*/_react["default"].createElement(DayElement, {
    isSelected: isSelected,
    isToday: cellDate.isCurrentDate()
  }, date));
};

exports.DayCell = DayCell;